<template>
  <v-button
    v-bind="$attrs"
    :ghost="!isActive"
    small
    :class="`button-group-button px-0 ${isActive ? '--active' : ''}`"
    @click="() => $emit('click')"
  >
    <slot />
  </v-button>
</template>

<script>
export default {
  props: {
    isActive: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.button-group-button {
  flex-grow: 1;
  min-height: 32px;
  min-width: 32px;
  margin: 0 2px;
  transition: background 0.2s ease, box-shadow 0.4s ease;
  font-weight: 600;
  box-shadow: $box-shadow--small;
  color: $color-ui--black;

  &:not(.--active) {
    background: transparent;
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
    color: $color-ui--grey-80 !important;
  }
}
</style>
